import { view } from '@yola/ws-sdk';
import getBreakpointForCurrentDevice from 'src/js/modules/breakpoint-editing/helpers/get-breakpoint-for-current-device';

const { breakpointModifiers } = view;

const getCurrentHideOnBreakpoint = () => getBreakpointForCurrentDevice(breakpointModifiers.ONLY);

export default getCurrentHideOnBreakpoint;
